(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hm-catering-quoteV2"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  function pad(n) { return String(n).padStart(2, '0'); }
  function ymd(d) { return d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate()); }
  function parseISO(iso) { var p = iso.split('-'); return new Date(+p[0], +p[1] - 1, +p[2]); }
  function prettyDate(iso) {
    return parseISO(iso).toLocaleDateString('en-US', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' });
  }
  function shortDate(iso) {
    return parseISO(iso).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
  }

  function initRoot(root) {
    var form = root.querySelector('form.cq-form');
    if (!form || root.getAttribute('data-cq-ready') === '1') return;
    root.setAttribute('data-cq-ready', '1');

    // Custom validation + alert replace browser bubbles (no-JS visitors keep native validation).
    form.noValidate = true;

    var alertEl = root.querySelector('[data-cq-alert]');
    var alertTitle = alertEl.querySelector('[data-cq-alert-title]');
    var alertText = alertEl.querySelector('[data-cq-alert-text]');
    var alertList = alertEl.querySelector('[data-cq-alert-list]');
    var dateInput = root.querySelector('[data-cq-date]');
    var dateSummary = root.querySelector('[data-cq-date-summary]');
    var submitBtn = root.querySelector('[data-cq-submit]');
    var submitLabel = submitBtn.textContent;
    var noticeDays = parseInt(root.getAttribute('data-notice-days'), 10);
    if (isNaN(noticeDays) || noticeDays < 0) noticeDays = 1;
    var submitting = false;

    /* ---------- Alert ---------- */
    function showAlert(type, title, messages) {
      alertEl.className = 'cq-alert cq-alert--' + type;
      alertTitle.textContent = title;
      alertText.hidden = true;
      alertList.innerHTML = '';
      (messages || []).forEach(function (m) {
        var li = document.createElement('li');
        li.textContent = m;
        alertList.appendChild(li);
      });
      alertList.hidden = !(messages && messages.length);
      alertEl.hidden = false;
    }
    function hideAlert() { alertEl.hidden = true; }
    alertEl.querySelector('[data-cq-alert-close]').addEventListener('click', hideAlert);

    // Server result (success / errors): bring it into view.
    if (!alertEl.hidden) {
      setTimeout(function () {
        alertEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
        try { alertEl.focus({ preventScroll: true }); } catch (e) {}
      }, 150);
    }

    /* ---------- Event date: earliest selectable ---------- */
    var earliest = new Date();
    earliest.setDate(earliest.getDate() + noticeDays);
    var minDate = ymd(earliest);
    if (dateInput) {
      dateInput.min = minDate;
      dateInput.addEventListener('click', function () {
        if (typeof dateInput.showPicker === 'function') {
          try { dateInput.showPicker(); } catch (e) {}
        }
      });
    }

    /* ---------- Invalid markers ---------- */
    function wrapperFor(el) {
      return el.closest('.cq-field, .cq-boxfield, .cq-selectbox, .cq-consent, .cq-textarea-wrap') || el;
    }
    function mark(el) {
      wrapperFor(el).classList.add('is-invalid');
      el.setAttribute('aria-invalid', 'true');
    }
    function clearMarks() {
      form.querySelectorAll('.is-invalid').forEach(function (n) { n.classList.remove('is-invalid'); });
      form.querySelectorAll('[aria-invalid]').forEach(function (n) { n.removeAttribute('aria-invalid'); });
    }
    function clearOne(e) {
      if (!e.target.closest) return;
      var w = e.target.closest('.is-invalid');
      if (!w) return;
      w.classList.remove('is-invalid');
      e.target.removeAttribute('aria-invalid');
    }
    form.addEventListener('input', clearOne);
    form.addEventListener('change', clearOne);

    /* ---------- Validation ---------- */
    function msgFor(el) {
      var custom = el.getAttribute('data-cq-msg');
      var label = el.getAttribute('data-cq-label') || 'This field';
      var v = el.validity;
      if (v.valueMissing) return custom || (label + ' is required');
      if (el.type === 'date') {
        if (v.rangeUnderflow) return label + ' must be ' + shortDate(el.min) + ' or later';
        return label + ' is not a valid date';
      }
      if (el.type === 'number') {
        if (v.rangeUnderflow) return label + ' must be at least ' + el.min;
        if (v.rangeOverflow) return label + ' must be ' + el.max + ' or fewer';
        return label + ' must be a whole number';
      }
      if (v.typeMismatch || v.patternMismatch) return label + ' looks invalid';
      return label + ' is invalid';
    }

    function validate() {
      clearMarks();
      var errors = [];
      Array.prototype.slice.call(form.elements).forEach(function (el) {
        if (!el.name || el.disabled || el.type === 'hidden' || el.type === 'submit' || el.type === 'button') return;
        if (el.checkValidity()) return;
        errors.push({ el: el, msg: msgFor(el) });
      });

      if (!errors.length) return true;

      var seen = {};
      var messages = [];
      errors.forEach(function (e) {
        mark(e.el);
        if (!seen[e.msg]) { seen[e.msg] = true; messages.push(e.msg); }
      });

      showAlert('error', 'Please fix the following before sending your request:', messages);

      var first = errors[0].el;
      wrapperFor(first).scrollIntoView({ behavior: 'smooth', block: 'center' });
      try { first.focus({ preventScroll: true }); } catch (e) {}
      return false;
    }

    /* ---------- Submit ---------- */
    form.addEventListener('submit', function (e) {
      if (submitting) { e.preventDefault(); return; }
      if (!validate()) { e.preventDefault(); return; }

      if (dateSummary) dateSummary.value = dateInput && dateInput.value ? prettyDate(dateInput.value) : '';

      hideAlert();
      submitting = true;
      submitBtn.disabled = true;
      submitBtn.setAttribute('aria-busy', 'true');
      submitBtn.textContent = submitBtn.getAttribute('data-busy-text') || submitLabel;
    });

    // Back button / bfcache: make the form usable again.
    window.addEventListener('pageshow', function (e) {
      if (!e.persisted) return;
      submitting = false;
      submitBtn.disabled = false;
      submitBtn.removeAttribute('aria-busy');
      submitBtn.textContent = submitLabel;
    });
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-cq-root]').forEach(initRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hm-pre-orderV2"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  var MAX_QTY = 99;

  function pad(n) { return String(n).padStart(2, '0'); }

  function ymd(d) {
    return d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate());
  }

  function parseISO(iso) {
    var p = iso.split('-');
    return new Date(+p[0], +p[1] - 1, +p[2]);
  }

  function prettyDate(iso) {
    if (!iso) return '';
    return parseISO(iso).toLocaleDateString('en-US', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' });
  }

  function shortDate(iso) {
    return parseISO(iso).toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
  }

  function prettyTime(t) {
    if (!t) return '';
    var p = t.split(':');
    var h = parseInt(p[0], 10);
    var ap = h >= 12 ? 'PM' : 'AM';
    h = h % 12 || 12;
    return h + ':' + p[1] + ' ' + ap;
  }

  function initRoot(root) {
    var form = root.querySelector('form.holiday-order-form');
    if (!form || root.getAttribute('data-ho-ready') === '1') return;
    root.setAttribute('data-ho-ready', '1');

    // Custom validation + alert replace the browser bubbles (no-JS visitors keep native validation).
    form.noValidate = true;

    var alertEl = root.querySelector('[data-ho-alert]');
    var alertTitle = alertEl.querySelector('[data-ho-alert-title]');
    var alertList = alertEl.querySelector('[data-ho-alert-list]');
    var itemsWrap = root.querySelector('[data-ho-items]');
    var items = Array.prototype.slice.call(root.querySelectorAll('[data-ho-item]'));
    var dateInput = root.querySelector('[data-ho-date]');
    var timeInput = root.querySelector('[data-ho-time]');
    var hint = root.querySelector('[data-ho-pickup-hint]');
    var summaryInput = root.querySelector('[data-ho-summary]');
    var pickupSummaryInput = root.querySelector('[data-ho-pickup-summary]');
    var submitBtn = root.querySelector('[data-ho-submit]');
    var submitLabel = submitBtn.textContent;
    var noticeDays = parseInt(root.getAttribute('data-notice-days'), 10);
    if (isNaN(noticeDays) || noticeDays < 0) noticeDays = 1;
    var submitting = false;

    /* ---------- Alert ---------- */
    function showAlert(type, title, messages) {
      alertEl.className = 'ho-alert ho-alert--' + type;
      alertTitle.textContent = title;
      alertList.innerHTML = '';
      (messages || []).forEach(function (m) {
        var li = document.createElement('li');
        li.textContent = m;
        alertList.appendChild(li);
      });
      alertList.hidden = !(messages && messages.length);
      alertEl.hidden = false;
    }

    function hideAlert() { alertEl.hidden = true; }

    alertEl.querySelector('[data-ho-alert-close]').addEventListener('click', hideAlert);

    // Server result (success / errors): bring it into view.
    if (!alertEl.hidden) {
      setTimeout(function () {
        alertEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
        try { alertEl.focus({ preventScroll: true }); } catch (e) {}
      }, 150);
    }

    /* ---------- Invalid markers ---------- */
    function wrapperFor(el) {
      return el.closest('.ho-field, .ho-boxfield, .ho-consent, .ho-subpill-group, .ho-selectbox, .ho-pill-group, .ho-items') || el;
    }

    function mark(el) {
      wrapperFor(el).classList.add('is-invalid');
      if ('validity' in el) el.setAttribute('aria-invalid', 'true');
    }

    function clearMarks() {
      form.querySelectorAll('.is-invalid').forEach(function (n) { n.classList.remove('is-invalid'); });
      form.querySelectorAll('[aria-invalid]').forEach(function (n) { n.removeAttribute('aria-invalid'); });
    }

    function clearOne(e) {
      if (!e.target.closest) return;
      var w = e.target.closest('.is-invalid');
      if (!w) return;
      w.classList.remove('is-invalid');
      w.querySelectorAll('[aria-invalid]').forEach(function (n) { n.removeAttribute('aria-invalid'); });
      e.target.removeAttribute('aria-invalid');
    }

    form.addEventListener('input', clearOne);
    form.addEventListener('change', clearOne);

    /* ---------- Items: checkbox + stepper ---------- */
    items.forEach(function (item) {
      var checkbox = item.querySelector('[data-ho-checkbox]');
      var valueEl = item.querySelector('[data-ho-value]');
      var input = item.querySelector('[data-ho-input]');
      var minus = item.querySelector('[data-ho-minus]');
      var plus = item.querySelector('[data-ho-plus]');
      var details = item.querySelectorAll('[data-ho-detail-field]');

      function setQty(n) {
        n = Math.min(MAX_QTY, Math.max(0, parseInt(n, 10) || 0));
        input.value = n;
        valueEl.textContent = pad(n);
        checkbox.checked = n > 0;
        item.classList.toggle('is-selected', n > 0);
        // Unselected items send nothing: disabled fields are not submitted or validated.
        input.disabled = n === 0;
        details.forEach(function (f) { f.disabled = n === 0; });
        if (n > 0 && itemsWrap) itemsWrap.classList.remove('is-invalid');
      }

      plus.addEventListener('click', function () { setQty((parseInt(input.value, 10) || 0) + 1); });
      minus.addEventListener('click', function () { setQty((parseInt(input.value, 10) || 0) - 1); });
      checkbox.addEventListener('change', function () {
        if (checkbox.checked) {
          var current = parseInt(input.value, 10) || 0;
          setQty(current > 0 ? current : 1);
        } else {
          setQty(0);
        }
      });

      setQty(parseInt(input.value, 10) || 0);
    });

    /* ---------- Pickup date window (notice period + holiday window) ---------- */
    function applyWindow(announce) {
      if (!dateInput) return;
      var checked = form.querySelector('input[name="contact[Holiday]"]:checked');
      var holiday = checked ? checked.value : '';
      var hMin = checked ? (checked.getAttribute('data-min') || '') : '';
      var hMax = checked ? (checked.getAttribute('data-max') || '') : '';

      var earliest = new Date();
      earliest.setDate(earliest.getDate() + noticeDays);
      var nMin = ymd(earliest);

      var min = hMin && hMin > nMin ? hMin : nMin;
      var max = hMax || '';

      dateInput.min = min;
      if (max) dateInput.max = max; else dateInput.removeAttribute('max');

      var closed = max && max < min;
      var outside = dateInput.value && (dateInput.value < min || (max && dateInput.value > max));

      if (outside) {
        dateInput.value = '';
        if (announce) {
          showAlert('info', 'Please choose a new pickup date.', [
            'The date you picked is outside the pickup window' + (holiday ? ' for ' + holiday : '') + '.'
          ]);
        }
      }

      if (hint) {
        if (closed) {
          hint.textContent = 'Online pickup dates for ' + holiday + ' are not available right now. Please call us to place this order.';
        } else if (max) {
          hint.textContent = 'Pickup window for ' + holiday + ': ' + shortDate(min) + ' to ' + shortDate(max) + '.';
        } else {
          hint.textContent = 'Earliest available pickup: ' + shortDate(min) + '.';
        }
        hint.hidden = false;
      }
    }

    form.querySelectorAll('input[name="contact[Holiday]"]').forEach(function (r) {
      r.addEventListener('change', function () { applyWindow(true); });
    });
    applyWindow(false);

    // Whole date box opens the picker (Safari / Firefox have no overlay indicator).
    if (dateInput) {
      dateInput.addEventListener('click', function () {
        if (typeof dateInput.showPicker === 'function') {
          try { dateInput.showPicker(); } catch (e) {}
        }
      });
    }

    /* ---------- Validation ---------- */
    function msgFor(el) {
      var custom = el.getAttribute('data-ho-msg');
      var label = el.getAttribute('data-ho-label') || 'This field';
      var v = el.validity;
      if (v.valueMissing) return custom || (label + ' is required');
      if (v.rangeUnderflow || v.rangeOverflow) {
        if (el.type === 'time') {
          if (el.min && el.max) return label + ' must be between ' + prettyTime(el.min) + ' and ' + prettyTime(el.max);
          if (el.min) return label + ' must be ' + prettyTime(el.min) + ' or later';
          return label + ' must be ' + prettyTime(el.max) + ' or earlier';
        }
        return label + ' is outside the available pickup window';
      }
      if (v.typeMismatch || v.patternMismatch) return label + ' looks invalid';
      return label + ' is invalid';
    }

    function validate() {
      clearMarks();
      var errors = [];
      var seenRadios = {};

      Array.prototype.slice.call(form.elements).forEach(function (el) {
        if (!el.name || el.disabled || el.type === 'hidden' || el.type === 'submit' || el.type === 'button') return;
        if (el.type === 'radio') {
          if (seenRadios[el.name]) return;
          seenRadios[el.name] = true;
        }
        if (el.checkValidity()) return;
        errors.push({ el: el, msg: msgFor(el) });
      });

      var anyItem = items.some(function (item) {
        var input = item.querySelector('[data-ho-input]');
        return (parseInt(input.value, 10) || 0) > 0;
      });
      if (!anyItem && itemsWrap) {
        errors.push({ el: itemsWrap, msg: 'Select at least one holiday item' });
      }

      errors.sort(function (a, b) {
        return a.el.compareDocumentPosition(b.el) & 4 ? -1 : 1;
      });

      if (!errors.length) return true;

      var seenMsgs = {};
      var messages = [];
      errors.forEach(function (e) {
        mark(e.el);
        if (!seenMsgs[e.msg]) { seenMsgs[e.msg] = true; messages.push(e.msg); }
      });

      showAlert('error', 'Please fix the following before placing your order:', messages);

      var first = errors[0].el;
      var target = wrapperFor(first);
      target.scrollIntoView({ behavior: 'smooth', block: 'center' });
      try { first.focus({ preventScroll: true }); } catch (e) {}
      return false;
    }

    /* ---------- Readable summaries for the order email ---------- */
    function buildSummary() {
      var holidayEl = form.querySelector('input[name="contact[Holiday]"]:checked');
      var lines = [];

      items.forEach(function (item) {
        var qty = parseInt(item.querySelector('[data-ho-input]').value, 10) || 0;
        if (qty < 1) return;
        var name = item.querySelector('.ho-item-name').textContent.trim();
        var extras = [];
        item.querySelectorAll('.ho-item-detail input:checked, .ho-item-detail select').forEach(function (f) {
          if (f.value) extras.push(f.value);
        });
        lines.push(qty + ' x ' + name + (extras.length ? ' (' + extras.join(', ') + ')' : ''));
      });

      summaryInput.value = (holidayEl ? holidayEl.value + ': ' : '') + lines.join('; ');

      var parts = [];
      if (dateInput && dateInput.value) parts.push(prettyDate(dateInput.value));
      if (timeInput && timeInput.value) parts.push(prettyTime(timeInput.value));
      pickupSummaryInput.value = parts.join(' at ');
    }

    /* ---------- Submit ---------- */
    form.addEventListener('submit', function (e) {
      if (submitting) { e.preventDefault(); return; }
      if (!validate()) { e.preventDefault(); return; }

      buildSummary();
      hideAlert();
      submitting = true;
      submitBtn.disabled = true;
      submitBtn.setAttribute('aria-busy', 'true');
      submitBtn.textContent = submitBtn.getAttribute('data-busy-text') || submitLabel;
    });

    // Back button / bfcache: make the form usable again.
    window.addEventListener('pageshow', function (e) {
      if (!e.persisted) return;
      submitting = false;
      submitBtn.disabled = false;
      submitBtn.removeAttribute('aria-busy');
      submitBtn.textContent = submitLabel;
    });
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-ho-root]').forEach(initRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  // Theme editor: re-initialise when the section is added or re-rendered.
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();

  } catch(e) { console.error(e); }
})();
})();
